//规范请参考http://www.datypic.com/sc/ooxml/ss.html，OpenXML规范，Office2007-2013遵循的规范
//另外可以通过修改成zip文件查看样式变动来参考，获取样式修改代码
define('services/common/exportExcel',['app', 'angular'], function (app, angular) {

    return app.factory('ExportExcel', ['$q', function ($q) {
        //导出组件
        var EXCEL = {};
        (function runFun() {
            EXCEL.version = '';
            var encoding = {'&quot;': '"', '&amp;': '&', '&gt;': '>', '&apos;': "'", '&lt;': '<'};//配置项

            function evert(objs) {
                var arr = ([])
                var key = keys(objs);
                for (var i = 0; i !== key.length; ++i) {
                    arr[objs[key[i]]] = key[i];
                }
                return arr;
            }

            var rencoding = evert(encoding);
            var decregex = /[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;

            function wxtHelper(h) {
                return keys(h).map(function (k) {
                    return " " + k + '="' + h[k] + '"';
                }).join("");
            }

            function escapeXML(text) {
                var s = text + '';
                return s.replace(decregex, function (y) {
                    return rencoding[y];
                }).replace(charegex, function (s) {
                    return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
                });
            }

            var ct2type = ({
                /* Workbook */
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
                /* File Properties */
                "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
                "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
                "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
                /* Calculation Chain */
                "application/vnd.ms-excel.calcChain": "calcchains",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

                /* External Links */
                "application/vnd.ms-excel.externalLink": "links",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
                /* Themes */
                "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
                /* VBA */
                "application/vnd.ms-office.vbaProject": "vba",
                "application/vnd.ms-office.vbaProjectSignature": "vba",

                /* Drawing */
                "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
                "application/vnd.openxmlformats-package.relationships+xml": "rels",

                "sheet": "js"
            });

            function reversKeyVal(obj) {
                var key = keys(obj);
                var arr = [];
                for (var i = 0; i !== key.length; ++i) {
                    if (arr[obj[key[i]]] == null) arr[obj[key[i]]] = [];
                    arr[obj[key[i]]].push(key[i]);
                }
                return arr;
            }

            var CT_LIST = (function () {
                var o = {
                    strs: {
                        /* Shared Strings */
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                    },
                    workbooks: {
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                    },
                    comments: {
                        /* Comments */
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                    },
                    sheets: {
                        /* Worksheet */
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                    },
                    charts: {
                        /* Chartsheet */
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml"
                    },
                    dialogs: {
                        /* Dialogsheet */
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml"
                    },
                    macros: {
                        /* Macrosheet (Excel 4.0 Macros) */
                        xlsx: "application/vnd.ms-excel.macrosheet+xml"
                    },
                    styles: {
                        /* Styles */
                        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                    }
                };
                //修改ct2Type添加xlsx
                keys(o).forEach(function (k) {
                    keys(o[k]).forEach(function (v) {
                        ct2type[o[k][v]] = k;
                    });
                });
                return o;
            })();

            var type2ct = reversKeyVal(ct2type);

            var XMLNS = ({
                'dcmitype': 'http://purl.org/dc/dcmitype/',
                'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
                'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
                'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
                'xsd': 'http://www.w3.org/2001/XMLSchema'
            });
            XMLNS.xsi ='http://www.w3.org/2001/XMLSchema-instance';
            XMLNS.dc ='http://purl.org/dc/elements/1.1/';
            XMLNS.dcterms ='http://purl.org/dc/terms/';
            XMLNS.sjs ='http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties';
            XMLNS.main = [
                'http://schemas.openxmlformats.org/spreadsheetml/2006/main?1',
                'http://purl.oclc.org/ooxml/spreadsheetml/main?2',
                'http://schemas.microsoft.com/office/excel/2006/main',
                'http://schemas.microsoft.com/office/excel/2006/2?1'
            ];
            XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
            XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';
            XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';
            XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
            XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";


            var CTYPE_XML_ROOT = writextag('Types', null, {
                'xmlns': XMLNS.CT,
                'xmlns:xsd': XMLNS.xsd,
                'xmlns:xsi': XMLNS.xsi
            });
            var WS_XML_ROOT = writextag('worksheet', null, {
                'xmlns': XMLNS.main[0],
                'xmlns:r': XMLNS.r
            });

            var STYLES_XML_ROOT = writextag('styleSheet', null, {
                'xmlns': XMLNS.main[0],
                'xmlns:vt': XMLNS.vt
            });
            var RELS_ROOT = writextag('Relationships', null, {
                'xmlns': XMLNS.RELS
            });
            var CTYPE_DEFAULTS = [['xml', 'application/xml'], ['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'], ['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'], ['bmp', 'image/bmp'], ['png', 'image/png'], ['gif', 'image/gif'], ['emf', 'image/x-emf'], ['wmf', 'image/x-wmf'], ['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'], ['tif', 'image/tiff'], ['tiff', 'image/tiff'], ['pdf', 'application/pdf'], ['rels', type2ct.rels[0]]].map(function (x) {
                return writextag('Default', null, {'Extension': x[0], 'ContentType': x[1]});
            });
            var RELS = ({
                WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
            });
            RELS.CORE_PROPS = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';
            RELS.EXT_PROPS = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';
            RELS.CUST_PROPS = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';
            RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";

            RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
            RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
            RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
            RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
            RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
            RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
            RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
            RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
            RELS.WS = [
                "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
            ];
            var shapeId = 1024;
            var strs = {}; // shared strings

            var WB_XML_ROOT = writextag('workbook', null, {
                'xmlns': XMLNS.main[0],
                'xmlns:r': XMLNS.r
            });

            function keys(o) {
                var ks = Object.keys(o);
                var arr = [];
                for (var i = 0; i < ks.length; ++i) {
                    if (Object.prototype.hasOwnProperty.call(o,ks[i])) {
                        arr.push(ks[i])
                    }
                }
                return arr;
            }

            //以下用于指定JSON中的指定单元格
            var badchars = "][*?\/\\".split("");

            function checkName(sheetName, safe) {
                if (sheetName.length > 31) {
                    if (safe) return false;
                    throw new Error("Sheet names cannot   exceed 31 chars");
                }
                var _good = true;
                badchars.forEach(function (c) {
                    if (sheetName.indexOf(c) == -1) return;
                    if (!safe) throw new Error("Sheet name   cannot contain : \\ / ? * [ ]");
                    _good = false;
                });
                return _good;
            }

            //要求json是[{}]的形式
            function json2Sheet(jsonArr, opts) {
                var o = opts || {};
                var offset = +!o.skipHeader;
                var ws = {};
                varcol = 0;
                var row = 0;
                var range = {start: {row: 0, col: 0}, end: {row: jsonArr.length, col: 0}};
                var colIdx = 0;
                var headerCols = o.header || [];
                jsonArr.forEach(function (json, rowIdx) {
                    keys(json).forEach(function (k) {
                        if ((colIdx = headerCols.indexOf(k)) == -1) {
                            headerCols[colIdx = headerCols.length] = k;
                        }
                        var val = json[k];
                        if (val && typeof val === 'object' && !(val instanceof Date)) {
                            ws[colIdx + ':' + (rowIdx + offset)] = val;
                        } else {
                            ws[colIdx + ':' + (rowIdx + offset)] = ({t: 's', v: val});
                        }
                    });
                });
                //从0开始
                range.end.col = headerCols.length - 1;
                //指定头则补充下头数据
                if (offset) {
                    for (var i = 0; i < headerCols.length; ++i) ws[i + ":0"] = {
                        t: 's',
                        v: headerCols[i]
                    };
                }
                ws['!ref'] = range
                return ws;
            }

            var htmldecode = (function () {
                var entities = [
                    ['nbsp', ' '], ['middot', '·'],
                    ['quot', '"'], ['apos', "'"], ['gt', '>'], ['lt', '<'], ['amp', '&']
                ].map(function (x) {
                    return [new RegExp('&' + x[0] + ';', "g"), x[1]];
                });
                return function htmldecode(str) {
                    var o1 = str.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, "\n").replace(/<[^>]*>/g, "");
                    for (var i = 0; i < entities.length; ++i) o1 = o1.replace(entities[i][0], entities[i][1]);
                    return o1;
                };
            })();
            //table的Dom解析出sheet
            function parse_dom_table(table, _opts) {
                var opts = _opts || {};
                var ws = {};
                var rows = table.getElementsByTagName('tr');
                var sheetRows1 = opts.sheetRows || 10000000;
                var range = {start: {row: 0, col: 0}, end: {row: 0, col: 0}};
                var merges = [], mergeIdx = 0;
                var rowinfo = [];
                var i = 0, rowIdx = 0, j, colIdx, rowSpan, colSpan;
                for (; i < rows.length && rowIdx < sheetRows1; ++i) {
                    var row = rows[i];
                    var elements = row.children;
                    for (j = colIdx = 0; j < elements.length; ++j) {
                        var elt = elements[j];
                        var v = htmldecode(elt.innerHTML);
                        for (mergeIdx = 0; mergeIdx < merges.length; ++mergeIdx) {
                            var mergeElement = merges[mergeIdx];
                            if (mergeElement.start.col == colIdx && mergeElement.start.row <= rowIdx && rowIdx <= mergeElement.end.row) {
                                colIdx = mergeElement.end.col + 1;
                                mergeIdx = -1;
                            }
                        }
                        colSpan = +elt.getAttribute("colspan") || 1;
                        if ((rowSpan = +elt.getAttribute("rowspan")) > 0 || colSpan > 1) {
                            merges.push({
                                start: {row: rowIdx, col: colIdx},
                                end: {row: rowIdx + (rowSpan || 1) - 1, col: colIdx + colSpan - 1}
                            });
                        }
                        var o = {t: 's', v: v};
                        ws[colIdx + ':' + rowIdx] = o;
                        if (range.end.col < colIdx) range.end.col = colIdx;
                        colIdx += colSpan;
                    }
                    ++rowIdx;
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws['!rows'] = rowinfo;
                range.end.row = rowIdx - 1;
                ws['!ref'] = range;
                if (rowIdx >= sheetRows1) throw new Error("Too many data ");
                return ws;
            }

            function sheet2Wb(sheet, opts) {
                var sheetName = opts && opts.sheet ? opts.sheet : "Sheet1";
                var sheets1 = {};
                sheets1[sheetName] = sheet;
                return {SheetNames: [sheetName], Sheets: sheets1};
            }

            function table2Wb(table, opts) {
                return sheet2Wb(parse_dom_table(table, opts), opts);
            }

            var utils = {
                json2Sheet: json2Sheet,
                table2Wb: table2Wb
            };
            utils.newWb = function () {
                return {SheetNames: [], Sheets: {}};
            };

            utils.appendSheet = function (wb, ws, name) {
                if (!name) for (var i = 1; i <= 0xFFFF; ++i) if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
                if (!name) throw new Error("Too many worksheets");
                checkName(name);
                if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with  name |" + name + "| already exists!");

                wb.SheetNames.push(name);
                wb.Sheets[name] = ws;
            };

            //写xl/theme/theme1.xml文件
            function writeTheme(Themes, opts) {
                if (opts && opts.themeXLSX) return opts.themeXLSX;
                var ot = [XML_HEADER];
                ot[ot.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
                ot[ot.length] = '<a:themeElements>';

                ot[ot.length] = '<a:clrScheme name="Office">';
                ot[ot.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
                ot[ot.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
                ot[ot.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
                ot[ot.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
                ot[ot.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
                ot[ot.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
                ot[ot.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
                ot[ot.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
                ot[ot.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
                ot[ot.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
                ot[ot.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
                ot[ot.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
                ot[ot.length] = '</a:clrScheme>';

                ot[ot.length] = '<a:fontScheme name="Office">';
                ot[ot.length] = '<a:majorFont>';
                ot[ot.length] = '<a:latin typeface="Cambria"/>';
                ot[ot.length] = '<a:ea typeface=""/>';
                ot[ot.length] = '<a:cs typeface=""/>';
                ot[ot.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
                ot[ot.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
                ot[ot.length] = '<a:font script="Hans" typeface="宋体"/>';
                ot[ot.length] = '<a:font script="Hant" typeface="新細明體"/>';
                ot[ot.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
                ot[ot.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
                ot[ot.length] = '<a:font script="Thai" typeface="Tahoma"/>';
                ot[ot.length] = '<a:font script="Ethi" typeface="Nyala"/>';
                ot[ot.length] = '<a:font script="Beng" typeface="Vrinda"/>';
                ot[ot.length] = '<a:font script="Gujr" typeface="Shruti"/>';
                ot[ot.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
                ot[ot.length] = '<a:font script="Knda" typeface="Tunga"/>';
                ot[ot.length] = '<a:font script="Guru" typeface="Raavi"/>';
                ot[ot.length] = '<a:font script="Cans" typeface="Euphemia"/>';
                ot[ot.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
                ot[ot.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
                ot[ot.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
                ot[ot.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
                ot[ot.length] = '<a:font script="Deva" typeface="Mangal"/>';
                ot[ot.length] = '<a:font script="Telu" typeface="Gautami"/>';
                ot[ot.length] = '<a:font script="Taml" typeface="Latha"/>';
                ot[ot.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
                ot[ot.length] = '<a:font script="Orya" typeface="Kalinga"/>';
                ot[ot.length] = '<a:font script="Mlym" typeface="Kartika"/>';
                ot[ot.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
                ot[ot.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
                ot[ot.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
                ot[ot.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
                ot[ot.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
                ot[ot.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
                ot[ot.length] = '</a:majorFont>';
                ot[ot.length] = '<a:minorFont>';
                ot[ot.length] = '<a:latin typeface="Calibri"/>';
                ot[ot.length] = '<a:ea typeface=""/>';
                ot[ot.length] = '<a:cs typeface=""/>';
                ot[ot.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
                ot[ot.length] = '<a:font script="Hang" typeface="맑은 고딕"/>';
                ot[ot.length] = '<a:font script="Hans" typeface="宋体"/>';
                ot[ot.length] = '<a:font script="Hant" typeface="新細明體"/>';
                ot[ot.length] = '<a:font script="Arab" typeface="Arial"/>';
                ot[ot.length] = '<a:font script="Hebr" typeface="Arial"/>';
                ot[ot.length] = '<a:font script="Thai" typeface="Tahoma"/>';
                ot[ot.length] = '<a:font script="Ethi" typeface="Nyala"/>';
                ot[ot.length] = '<a:font script="Beng" typeface="Vrinda"/>';
                ot[ot.length] = '<a:font script="Gujr" typeface="Shruti"/>';
                ot[ot.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
                ot[ot.length] = '<a:font script="Knda" typeface="Tunga"/>';
                ot[ot.length] = '<a:font script="Guru" typeface="Raavi"/>';
                ot[ot.length] = '<a:font script="Cans" typeface="Euphemia"/>';
                ot[ot.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
                ot[ot.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
                ot[ot.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
                ot[ot.length] = '<a:font script="Thaa" typeface="MV Boli" />';
                ot[ot.length] = '<a:font script="Deva" typeface="Mangal"/>';
                ot[ot.length] = '<a:font script="Telu" typeface="Gautami"/>';
                ot[ot.length] = '<a:font script="Taml" typeface="Latha"/>';
                ot[ot.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
                ot[ot.length] = '<a:font script="Orya" typeface="Kalinga"/>';
                ot[ot.length] = '<a:font script="Mlym" typeface="Kartika"/>';
                ot[ot.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
                ot[ot.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
                ot[ot.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
                ot[ot.length] = '<a:font script="Viet" typeface="Arial"/>';
                ot[ot.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
                ot[ot.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
                ot[ot.length] = '</a:minorFont>';
                ot[ot.length] = '</a:fontScheme>';

                ot[ot.length] = '<a:fmtScheme name="Office">';
                ot[ot.length] = '<a:fillStyleLst>';
                ot[ot.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
                ot[ot.length] = '<a:gradFill rotWithShape="1">';
                ot[ot.length] = '<a:gsLst>';
                ot[ot.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '</a:gsLst>';
                ot[ot.length] = '<a:lin ang="16200000" scaled="1"/>';
                ot[ot.length] = '</a:gradFill>';
                ot[ot.length] = '<a:gradFill rotWithShape="1">';
                ot[ot.length] = '<a:gsLst>';
                ot[ot.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '</a:gsLst>';
                ot[ot.length] = '<a:lin ang="16200000" scaled="0"/>';
                ot[ot.length] = '</a:gradFill>';
                ot[ot.length] = '</a:fillStyleLst>';
                ot[ot.length] = '<a:lnStyleLst>';
                ot[ot.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
                ot[ot.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
                ot[ot.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
                ot[ot.length] = '</a:lnStyleLst>';
                ot[ot.length] = '<a:effectStyleLst>';
                ot[ot.length] = '<a:effectStyle>';
                ot[ot.length] = '<a:effectLst>';
                ot[ot.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
                ot[ot.length] = '</a:effectLst>';
                ot[ot.length] = '</a:effectStyle>';
                ot[ot.length] = '<a:effectStyle>';
                ot[ot.length] = '<a:effectLst>';
                ot[ot.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
                ot[ot.length] = '</a:effectLst>';
                ot[ot.length] = '</a:effectStyle>';
                ot[ot.length] = '<a:effectStyle>';
                ot[ot.length] = '<a:effectLst>';
                ot[ot.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
                ot[ot.length] = '</a:effectLst>';
                ot[ot.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
                ot[ot.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
                ot[ot.length] = '</a:effectStyle>';
                ot[ot.length] = '</a:effectStyleLst>';
                ot[ot.length] = '<a:bgFillStyleLst>';
                ot[ot.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
                ot[ot.length] = '<a:gradFill rotWithShape="1">';
                ot[ot.length] = '<a:gsLst>';
                ot[ot.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '</a:gsLst>';
                ot[ot.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
                ot[ot.length] = '</a:gradFill>';
                ot[ot.length] = '<a:gradFill rotWithShape="1">';
                ot[ot.length] = '<a:gsLst>';
                ot[ot.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
                ot[ot.length] = '</a:gsLst>';
                ot[ot.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
                ot[ot.length] = '</a:gradFill>';
                ot[ot.length] = '</a:bgFillStyleLst>';
                ot[ot.length] = '</a:fmtScheme>';
                ot[ot.length] = '</a:themeElements>';

                ot[ot.length] = '<a:objectDefaults>';
                ot[ot.length] = '<a:spDef>';
                ot[ot.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
                ot[ot.length] = '</a:spDef>';
                ot[ot.length] = '<a:lnDef>';
                ot[ot.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
                ot[ot.length] = '</a:lnDef>';
                ot[ot.length] = '</a:objectDefaults>';
                ot[ot.length] = '<a:extraClrSchemeLst/>';
                ot[ot.length] = '</a:theme>';
                return ot.join("");
            }

            //参数先保留
            function writeWorkbook(wb, name, opts) {
                var o = [XML_HEADER];
                o[o.length] = WB_XML_ROOT;

                var workbookPr = ({codeName: "ThisWorkbook"});
                o[o.length] = (writextag('workbookPr', null, workbookPr));
                o[o.length] = "<sheets>";
                var sheets = [];
                for (var i = 0; i != wb.SheetNames.length; ++i) {
                    var sht = ({name: escapeXML(wb.SheetNames[i].slice(0, 31))});
                    sht.sheetId = "" + (i + 1);
                    sht["r:id"] = "rId" + (i + 1);
                    o[o.length] = (writextag('sheet', null, sht));
                }
                o[o.length] = "</sheets>";

                if (o.length > 2) {
                    o[o.length] = '</workbook>';
                    o[1] = o[1].replace("/>", ">");
                }
                return o.join("");
            }

            function writeCellXfs(cellXfs) {
                var o = [];
                o[o.length] = writextag('cellXfs', null);
                cellXfs.forEach(function (c) {
                    o[o.length] = writextag('xf', null, c);
                });
                o[o.length] = '<xf numFmtId="0" fontId="1" fillId="2" borderId="1" xfId="1"><alignment horizontal="center" vertical="center"/></xf>';
                o[o.length] = ("</cellXfs>");
                if (o.length === 2) return "";

                o[0] = writextag('cellXfs', null, {count: o.length - 2}).replace("/>", ">");
                return o.join("");
            }

            function writeNumberFmts(numFormaters) {
                var o = ["<numFmts>"];
                [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (r) {
                    for (var i = r[0]; i <= r[1]; ++i) {
                        if (numFormaters[i] != null) {
                            o[o.length] = writextag('numFmt', null, {
                                numFmtId: i,
                                formatCode: escapeXML(numFormaters[i])
                            });
                        }
                    }
                });
                if (o.length === 1) return "";
                o[o.length] = ("</numFmts>");
                o[0] = writextag('numFmts', null, {count: o.length - 2}).replace("/>", ">");
                return o.join("");
            }

            //写xl/styles.xml
            function writeStyle(wb, name, opts) {
                var o = [XML_HEADER, STYLES_XML_ROOT]
                var tmp;
                if (wb.SSF && (tmp = writeNumberFmts(wb.SSF)) != null) {
                    o[o.length] = tmp
                }
                o[o.length] = ('<fonts count="2"> <font> <sz val="12"/> <color theme="1"/> <name val="宋体"/> <family val="2"/> <scheme val="minor"/> </font> <font> <b/> <sz val="12"/> <color theme="1"/> <name val="宋体"/> <family val="2"/> <scheme val="minor"/> </font> <font> <sz val="9"/> <name val="宋体"/> <family val="3"/> <charset val="134"/> <scheme val="minor"/> </font></fonts>');
                o[o.length] = ('<fills count="3"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill> <fill> <patternFill patternType="solid"> <fgColor theme="8" tint="0.39997558519241921"/> <bgColor indexed="64"/> </patternFill> </fill></fills>');
                o[o.length] = ('<borders count="2"><border><left/><right/><top/><bottom/><diagonal/></border><border><left style="thin"><color auto="1"/></left><right style="thin"><color auto="1"/></right><top style="thin"><color auto="1"/></top><bottom style="thin"><color auto="1"/></bottom><diagonal/></border></borders>');
                o[o.length] = ('<cellStyleXfs count="2"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="1"><alignment horizontal="center" vertical="center"/></xf></cellStyleXfs>');
                if ((tmp = writeCellXfs(opts.cellXfs))) {
                    o[o.length] = (tmp);
                }
                o[o.length] = ('<cellStyles count="2"><cellStyle name="Normal" xfId="0" builtinId="0"/><cellStyle name="HeaderStyle" xfId="1"/></cellStyles>');

                if (o.length > 2) {
                    o[o.length] = ('</styleSheet>');
                    o[1] = o[1].replace("/>", ">");
                }
                return o.join("");
            }

            function writeCT(ct, opts) {
                var o = [], v;
                o[o.length] = XML_HEADER;
                o[o.length] = CTYPE_XML_ROOT;
                o = o.concat(CTYPE_DEFAULTS);
                var ft1 = function (w) {
                    if (ct[w] && ct[w].length > 0) {
                        v = ct[w][0];
                        o[o.length] = (writextag('Override', null, {
                            'PartName': (v[0] == '/' ? "" : "/") + v,
                            'ContentType': CT_LIST[w]['xlsx']
                        }));
                    }
                };
                var ft2 = function (w) {
                    (ct[w] || []).forEach(function (v) {
                        o[o.length] = (writextag('Override', null, {
                            'PartName': (v[0] == '/' ? "" : "/") + v,
                            'ContentType': CT_LIST[w]['xlsx']
                        }));
                    });
                };
                var ft3 = function (t) {
                    (ct[t] || []).forEach(function (k) {
                        o[o.length] = (writextag('Override', null, {
                            'PartName': (k[0] == '/' ? "" : "/") + k,
                            'ContentType': type2ct[t][0]
                        }));
                    });
                };
                ft1('workbooks');
                ft2('sheets');
                ft2('charts');
                ft3('themes');
                ['strs', 'styles'].forEach(ft1);
                ['coreprops', 'extprops', 'custprops'].forEach(ft3);
                ft3('vba');
                ft3('comments');
                ft3('drawings');
                if (o.length > 2) {
                    o[o.length] = ('</Types>');
                    o[1] = o[1].replace("/>", ">");
                }
                return o.join("");
            }

            //写入excel的xml文件中的rels文件目录中的文件
            function writeRels(rels) {
                var o = [XML_HEADER, RELS_ROOT];
                keys(rels['!id']).forEach(function (rid) {
                    o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
                });
                if (o.length > 2) {
                    o[o.length] = ('</Relationships>');
                    o[1] = o[1].replace("/>", ">");
                }
                return o.join("");
            }

            function writetag(f, g) {
                return '<' + f + (g.match(wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
            }

            //反转键值对
            function reverseKeyVal(obj) {
                var o = ([]), key = keys(obj);
                for (var i = 0; i !== key.length; ++i) o[obj[key[i]]] = parseInt(key[i], 10);
                return o;
            }

            //转换0列到A列
            function name2excelIndex(num) {
                return String.fromCharCode(parseInt(num) + 65);
            }

            function writeCell(cell, ref, ws, opts, idx, wb,row) {
                if (cell.v === undefined) return "";
                var v = writetag('v', escapeXML(cell.v));
                //转换成A1，B2的形式
                var refVal = name2excelIndex(ref.split(":")[0]) + "" + (parseInt(ref.split(":")[1]) + 1);
                var o = ({r: refVal, t: 'str'});
                //第一行应用表头样式
                if(row == 0){
                    o.s = "2";
                }
                return writextag('c', v, o);
            }

            function writeData(ws, opts, idx, wb) {
                var o = [], r = [], range = ws['!ref'], cell = "", ref, rowStr = "", row = 0, col = 0;
                var params = ({r: rowStr});
                for (row = range.start.row; row <= range.end.row; ++row) {
                    r = [];
                    rowStr = "" + (row + 1);
                    for (col = range.start.col; col <= range.end.col; ++col) {
                        ref = col + ":" + row;
                        var _cell = ws[ref];
                        if (_cell === undefined) continue;
                        if ((cell = writeCell(_cell, ref, ws, opts, idx, wb, row)) != null) {
                            r.push(cell);
                        }
                    }
                    if (r.length > 0) {
                        params = ({r: rowStr});
                        if(row == 0){
                            params["ht"] = "23.25";
                            params["customHeight"] = "1";
                        }
                        o[o.length] = (writextag('row', r.join(""), params));
                    }
                }
                return o.join("");
            }

            function writeSheet(idx, f, opts, wb, rels) {
                var ot = [XML_HEADER, WS_XML_ROOT];
                var s = wb.SheetNames[idx], sidx = 0, rdata = "";
                var ws = wb.Sheets[s];
                if (ws == null) ws = {};
                var ref = ws['!ref'] || '0:1';
                if (!rels) rels = {};
                ws['!comments'] = [];
                ws['!drawing'] = [];
                ot[ot.length] = '<dimension ref="' + name2excelIndex(ref.start.col) + (ref.start.row + 1) + ':' + name2excelIndex(ref.end.col) + (ref.end.row + 1) + '"/>';
                ot[ot.length] = '<sheetViews><sheetView tabSelected="1" workbookViewId="0"/></sheetViews>';
                //指定默认行高
                ot[ot.length] = '<sheetFormatPr defaultRowHeight="13.5"/>';
                //指定列宽
                ot[ot.length] = '<cols> <col min="1" max="11" width="13.75" customWidth="1"/> </cols>';
                ot[sidx = ot.length] = '<sheetData/>';
                ws['!links'] = [];
                if (ref != null) {
                    rdata = writeData(ws, opts, idx, wb, rels);
                    if (rdata.length > 0) ot[ot.length] = (rdata);
                }
                if (ot.length > sidx + 1) {
                    ot[ot.length] = ('</sheetData>');
                    ot[sidx] = ot[sidx].replace("/>", ">");
                }
                ot[ot.length] = "";
                //合并功能暂时保留后期完善
                ot[ot.length] = writetag("ignoredErrors", writextag("ignoredError", null, {
                    numberStoredAsText: 1,
                    sqref: name2excelIndex(ref.start.col) + (ref.start.row + 1) + ':' + name2excelIndex(ref.end.col) + (ref.end.row + 1)
                }));
                if (ot.length > 2) {
                    ot[ot.length] = ('</worksheet>');
                    ot[1] = ot[1].replace("/>", ">");
                }
                return ot.join("");
            }

            var TABLE_FORMATS= {
                '1': '0',
                '4': '#,##0.00',
                '9': '0%',
                '10': '0.00%',
                '12': '# ?/?',
                '13': '# ??/??',
                '14': 'm/d/yy',
                '16': 'd-mmm',
                '18': 'h:mm AM/PM',
                '20': 'h:mm',
                '38': '#,##0 ,[Red](#,##0)',
                '37': '#,##0 ,(#,##0)',
                '40': '#,##0.00,[Red](#,##0.00)',
                '46': '[h]:mm:ss',
                '47': 'mmss.0',
                '49': '@',
                '56': '"上午/下午 "hh"時"mm"分"ss"秒 "',
                '65535': 'General'
            };
            TABLE_FORMATS['0']='General';
            TABLE_FORMATS['2']='0.00';
            TABLE_FORMATS['3']='#,##0';
            TABLE_FORMATS['11']='0.00E+00';
            TABLE_FORMATS['15']='d-mmm-yy';
            TABLE_FORMATS['17']='mmm-yy';
            TABLE_FORMATS['19']='h:mm:ss AM/PM';
            TABLE_FORMATS['21']='h:mm:ss';
            TABLE_FORMATS['22']='m/d/yy h:mm';
            TABLE_FORMATS['39']='#,##0.00,(#,##0.00)';
            TABLE_FORMATS['45']='mm:ss';
            TABLE_FORMATS['48']='##0.0E+0';
            var wtregex = /(^\s|\s$|\n)/;
            var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';

            function writextag(tag, context, attrs) {
                return '<' + tag + ((attrs != null) ? wxtHelper(attrs) : "") + ((context != null) ? (context.match(wtregex) ? ' xml:space="preserve"' : "") + '>' + context + '</' + tag : "/") + '>';
            }

            function addRels(rels, rId, f, type, relobj) {
                if (!relobj) relobj = {};
                if (!rels['!id']) rels['!id'] = {};
                if (rId < 0) for (rId = 1; rels['!id']['rId' + rId]; ++rId) {/* empty */
                }
                relobj.Id = 'rId' + rId;
                relobj.Target = f;
                relobj.Type = type;
                if (relobj.Type == RELS.HLINK) relobj.TargetMode = "External";
                if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
                rels['!id'][relobj.Id] = relobj;
                rels[('/' + relobj.Target).replace("//", "/")] = relobj;
                return rId;
            }

            function new_wb() {
                return ({
                    workbooks: [], sheets: [], charts: [], dialogs: [], macros: [],
                    rels: [], strs: [], comments: [], links: [],
                    coreprops: [],  custprops: [], extprops: [],themes: [], styles: [],
                    calcchains: [], vba: [], drawings: [],
                    TODO: [], xmlns: ""
                });
            }
            //生成文件内容
            function writeZip(wb, opts) {
                shapeId = 1024;
                wb.SSF = TABLE_FORMATS;
                opts.ssf = TABLE_FORMATS;
                opts.revssf = reverseKeyVal(wb.SSF);
                opts.revssf[TABLE_FORMATS[65535]] = 0;



                opts.rels = {};
                opts.wbrels = {};
                opts.Strings = [];
                opts.Strings.Unique = 0;
                opts.Strings.Count = 0;
                if (typeof Map !== 'undefined') {
                    opts.revStrings = new Map();
                } else {
                    opts.revStrings = {};
                    opts.revStrings.foo = [];
                    delete opts.revStrings.foo;
                }
                opts.cellDates = false;
                opts.compression = false;
                opts.bookSST = false;
                opts.WTF = false;
                var suffix1 = "xml";
                var zip = new StringBuffer();
                var ct = new_wb();
                var f1 = "", rId = 0;
                opts.cellXfs = [{
                    fontId: 0,
                    numFmtId: 0,
                    fillId: 0,
                    borderId: 0,
                    xfId: 0,
                    applyNumberFormat: 1
                },{

                    fontId: 0,
                    numFmtId: 0,
                    fillId: 0,
                    borderId: 0,
                    xfId: 1,
                    applyNumberFormat: 1
                }];
                wb.Props = {};
                wb.Props.SheetNames = wb.SheetNames;

                f1 = "docProps/core.xml";
                var fContext = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<cp:coreProperties xmlns:cp= "http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/>';
                zip.file(f1, fContext);
                ct.coreprops.push(f1);
                addRels(opts.rels, 2, f1, RELS.CORE_PROPS);

                f1 = "docProps/app.xml";
                wb.Props.Worksheets = wb.Props.SheetNames.length;
                fContext = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>SheetJS</Application><HeadingPairs><vt:vector size="2" baseType="variant"><vt:variant><vt:lpstr>Worksheets</vt:lpstr></vt:variant><vt:variant><vt:i4>1</vt:i4></vt:variant></vt:vector></HeadingPairs><TitlesOfParts><vt:vector size="1" baseType="lpstr"><vt:lpstr>Results</vt:lpstr></vt:vector></TitlesOfParts></Properties>';
                zip.file(f1, fContext);
                ct.extprops.push(f1);
                addRels(opts.rels, 3, f1, RELS.EXT_PROPS);

                for (rId = 1; rId <= wb.SheetNames.length; ++rId) {
                    var wsrels = {'!id': {}};
                    var ws = wb.Sheets[wb.SheetNames[rId - 1]];
                    f1 = "xl/worksheets/sheet" + rId + "." + suffix1;
                    zip.file(f1, writeSheet(rId - 1, f1, opts, wb, wsrels));
                    ct.sheets.push(f1);
                    addRels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + suffix1, RELS.WS[0]);
                }


                f1 = "xl/workbook." + suffix1;
                zip.file(f1, writeWorkbook(wb, f1, opts));
                ct.workbooks.push(f1);
                addRels(opts.rels, 1, f1, RELS.WB);

                f1 = "xl/theme/theme1.xml";
                zip.file(f1, writeTheme(wb.Themes, opts));
                ct.themes.push(f1);
                addRels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

                f1 = "xl/styles." + suffix1;
                zip.file(f1, writeStyle(wb, f1, opts));
                ct.styles.push(f1);
                addRels(opts.wbrels, -1, "styles." + suffix1, RELS.STY);


                zip.file("[Content_Types].xml", writeCT(ct, opts));
                zip.file('_rels/.rels', writeRels(opts.rels));
                zip.file('xl/_rels/workbook.' + suffix1 + '.rels', writeRels(opts.wbrels));

                delete opts.revssf;
                delete opts.ssf;
                return zip;
            }

            //集中处理excel的xml数据，整理成文件格式
            function StringBuffer() {
                files = [];
                function file(name, data) {
                    files[name] = {
                        name: name,
                        data: data
                    };
                    return files[name];
                }

                var string2buf = function (input) {
                    var buf, c1, c2, position, i, strLen = input.length, bufferLen = 0;
                    // count binary size
                    for (position = 0; position < strLen; position++) {
                        c1 = input.charCodeAt(position);
                        if (((c1 & 0xfc00) === 0xd800) && (position + 1 < strLen)) {
                            c2 = input.charCodeAt(position + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c1 = 0x10000 + ((c1 - 0xd800) << 10) + (c2 - 0xdc00);
                                position++;
                            }
                        }
                        bufferLen += (c1 < 0x80) ? 1 : ((c1 < 0x800) ? 2 : ((c1 < 0x10000) ? 3 : 4));
                    }
                    // allocate buffer
                    if (typeof Uint8Array !== "undefined") {
                        buf = new Uint8Array(bufferLen);
                    } else {
                        buf = new Array(bufferLen);
                    }
                    // convert
                    for (i = 0, position = 0; i < bufferLen; position++) {
                        c1 = input.charCodeAt(position);
                        if ((c1 & 0xfc00) === 0xd800 && (position + 1 < strLen)) {
                            c2 = input.charCodeAt(position + 1);
                            if ((c2 & 0xfc00) === 0xdc00) {
                                c1 = 0x10000 + ((c1 - 0xd800) << 10) + (c2 - 0xdc00);
                                position++;
                            }
                        }
                        if (c1 < 0x80) {
                            /* one byte */
                            buf[i++] = c1;
                        } else if (c1 < 0x800) {
                            /* two bytes */
                            buf[i++] = 0xC0 | (c1 >>> 6);
                            buf[i++] = 0x80 | (c1 & 0x3f);
                        } else if (c1 < 0x10000) {
                            /* three bytes */
                            buf[i++] = 0xE0 | (c1 >>> 12);
                            buf[i++] = 0x80 | ((c1 >>> 6) & 0x3f);
                            buf[i++] = 0x80 | (c1 & 0x3f);
                        } else {
                            /* four bytes */
                            buf[i++] = 0xf0 | (c1 >>> 18);
                            buf[i++] = 0x80 | ((c1 >>> 12) & 0x3f);
                            buf[i++] = 0x80 | ((c1 >>> 6) & 0x3f);
                            buf[i++] = 0x80 | (c1 & 0x3f);
                        }
                    }
                    return buf;
                };

                function arrayLikeToString(array) {
                    var chunk1 = 65536;
                    var result = [],
                        len = array.length,
                        type = "uint8array",
                        k = 0,
                        canUseApply = true;
                    try {
                        //可以加快速度,IE10+已经支持
                        String.fromCharCode.apply(null, new Uint8Array(0));
                    } catch (e) {
                        canUseApply = false;
                    }
                    if (!canUseApply) {
                        var resultStr1 = "";
                        for (var i = 0; i < array.length; i++) {
                            resultStr1 += String.fromCharCode(array[i]);
                        }
                        return resultStr1;
                    }
                    while (k < len && chunk1 > 1) {
                        try {
                            result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk1, len))));
                            k += chunk1;
                        }
                        catch (e) {
                            chunk1 = Math.floor(chunk1 / 2);
                        }
                    }
                    return result.join("");
                }

                var TABLE = [
                    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
                ];
                //数据校验算法
                function crc32(input, crc) {
                    if (typeof input === "undefined" || !input.length) {
                        return 0;
                    }
                    if (typeof (crc) == "undefined") {
                        crc = 0;
                    }
                    var val1 = 0;
                    var asciiCode1 = 0;
                    var code = 0;

                    crc = crc ^ (-1);
                    for (var i = 0, iTop = input.length; i < iTop; i++) {
                        code = input.charCodeAt(i);
                        asciiCode1 = (crc ^ code) & 0xFF;
                        val1 = TABLE[asciiCode1];
                        crc = (crc >>> 8) ^ val1;
                    }

                    return crc ^ (-1);
                }

                //十进制转换成16进制
                function numToHex(dec, bytes) {
                    var hex1 = "",
                        i;
                    for (i = 0; i < bytes; i++) {
                        hex1 += String.fromCharCode(dec & 0xff);
                        dec = dec >>> 8;
                    }
                    return hex1;
                }
                var SIGNATURE = {
                    LOCAL_FILE_HEADER: "PK\x03\x04",
                    CENTRAL_FILE_HEADER: "PK\x01\x02",
                    CENTRAL_DIRECTORY_END: "PK\x05\x06",
                    ZIP64_CENTRAL_DIRECTORY_LOCATOR: "PK\x06\x07",
                    ZIP64_CENTRAL_DIRECTORY_END: "PK\x06\x06",
                    DATA_DESCRIPTOR: "PK\x07\x08"
                }



                function assembleParts(name, file, result, offset) {
                    var datea = new Date();
                    var dosTime = datea.getHours();
                    dosTime = dosTime << 6;
                    dosTime = dosTime | datea.getMinutes();
                    dosTime = dosTime << 5;
                    dosTime = dosTime | datea.getSeconds() / 2;

                    var dosDate = datea.getFullYear() - 1980;
                    dosDate = dosDate << 4;
                    dosDate = dosDate | (datea.getMonth() + 1);
                    dosDate = dosDate << 5;
                    dosDate = dosDate | datea.getDate();
                    var headerh = "";

                    //file 方法放入的文件名要求不包含中文
                    headerh += "\x0A\x00\x00\x00";
                    headerh += result.compressionMethod;
                    headerh += numToHex(dosTime, 2);
                    headerh += numToHex(dosDate, 2);
                    headerh += numToHex(result.crc32, 4);
                    headerh += numToHex(result.compressedSize, 4);
                    headerh += numToHex(result.uncompressedSize, 4);
                    headerh += numToHex(name.length, 2);
                    headerh += numToHex(0, 2);
                    var fileRecord = SIGNATURE.LOCAL_FILE_HEADER + header + name;
                    var dirRecord = SIGNATURE.CENTRAL_FILE_HEADER +
                        "\x14\x00" +
                        headerh +
                        // file comment length
                        numToHex(0, 2) +
                        // disk number start
                        "\x00\x00" +
                        // internal file attributes
                        "\x00\x00" +
                        // external file attributes
                        ("\x00\x00\x00\x00") +
                        // relative offset of local header
                        numToHex(offset, 4) +
                        // file name
                        name +
                        // extra field
                        "" +
                        // file comment
                        "";
                    return {
                        fileRecord: fileRecord,
                        dirRecord: dirRecord,
                        compressedObject: result
                    };
                }

                //组装成Zip格式
                function generate() {
                    var zipData = [];
                    var centralDirLength = 0;
                    var localDirLength = 0;
                    for (var name in files) {
                        if (!Object.prototype.hasOwnProperty.call(files,name)) {
                            continue;
                        }
                        var file = files[name];
                        var result = {
                            compressedSize: 0,
                            uncompressedSize: 0,
                            crc32: 0,
                            compressionMethod: "\u0000\u0000",
                            compressedContent: null
                        };
                        //unicode转Ascii
                        var contents = arrayLikeToString(string2buf(file.data));
                        result.uncompressedSize = contents.length;
                        result.crc32 = crc32(contents);
                        result.compressedContent = contents;
                        result.compressedSize = result.compressedContent.length;

                        var zipPart = assembleParts.call(this, name, file, result, localDirLength);

                        localDirLength += zipPart.fileRecord.length + result.compressedSize;
                        centralDirLength += zipPart.dirRecord.length;
                        zipData.push(zipPart);
                    }

                    // end of central dir SIGNATURE
                    var dirEnd = SIGNATURE.CENTRAL_DIRECTORY_END +
                        // number of this disk
                        "\x00\x00" +
                        // number of the disk with the start of the central directory
                        "\x00\x00" +
                        // total number of entries in the central directory on this disk
                        numToHex(zipData.length, 2) +
                        // total number of entries in the central directory
                        numToHex(zipData.length, 2) +
                        // size of the central directory   4 bytes
                        numToHex(centralDirLength, 4) +
                        // offset of start of central directory with respect to the starting disk number
                        numToHex(localDirLength, 4) +
                        // .ZIP file comment length
                        numToHex(0, 2) +
                        // .ZIP file comment
                        "";

                    var rsData = [];
                    for (i = 0; i < zipData.length; i++) {
                        rsData.push(zipData[i].fileRecord);
                        rsData.push(zipData[i].compressedObject.compressedContent);
                    }
                    for (i = 0; i < zipData.length; i++) {
                        rsData.push(zipData[i].dirRecord);
                    }
                    rsData.push(dirEnd);

                    return rsData.join("");
                }

                return {
                    file: file,
                    generate: generate
                };
            }

            //转换成0-255的ASCII编码
            function blobify(data) {
                //IE+支持
                if (typeof ArrayBuffer === 'undefined') {
                    return data.split("").map(function (x) {
                        return x.charCodeAt(0) & 0xff;
                    });
                }
                var bufb = new ArrayBuffer(data.length);
                var viewb = new Uint8Array(bufb);
                for (var i = 0; i != data.length; ++i) viewb[i] = data.charCodeAt(i) & 0xFF;
                return bufb;
            }

            function downloadFile(fname, data) {
                if (typeof Blob !== 'undefined') {
                    var blob = new Blob([blobify(data)], {type: "application/octet-stream"});
                    if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
                    if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
                        var url = URL.createObjectURL(blob);
                        if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                            if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function () {
                                URL.revokeObjectURL(url);
                            }, 60000);
                            return chrome.downloads.download({url: url, filename: fname, saveAs: true});
                        }
                        var ah = document.createElement("a");
                        if (ah.download != null) {
                            ah.download = fname;
                            ah.href = url;
                            document.body.appendChild(ah);
                            ah.click();
                            document.body.removeChild(ah);
                            if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function () {
                                URL.revokeObjectURL(url);
                            }, 60000);
                            return url;
                        }
                    }
                }
                throw new Error("unsupported browser " + fname);
            }

            function writeFileSync(wb, filename, opts) {
                var ow = opts || {};
                ow.type = 'file';
                ow.file = filename;
                ow.bookType = "xlsx";
                var z = writeZip(wb, ow);
                var out = z.generate({type: 'string'});
                return downloadFile(ow.file, out);
            }

            EXCEL.writeFile = writeFileSync;
            EXCEL.utils = utils;
        })();

        return {
            data2Excel: function (data, fileName, sheetName) {
                var ws1 = EXCEL.utils.json2Sheet(data, {skipHeader: true});
                var wb1 = EXCEL.utils.newWb();
                EXCEL.utils.appendSheet(wb1, ws1, sheetName);
                EXCEL.writeFile(wb1, fileName);
            },
            table2Excel: function (tableId, fileName, sheetName) {
                var wb2 = EXCEL.utils.table2Wb(document.getElementById(tableId), {sheet: sheetName});
                EXCEL.writeFile(wb2, fileName);
            },
            test: function () {
                var data = JSON.parse('[{"Name":"Name","Index":"Index"}, {"Name":"Bill Clinton","Index":42},{"Name":"GeorgeW Bush","Index":43},{"Name":"Barack Obama","Index":44},{"Name":"Donald Trump","Index":45}]');
                var ws = EXCEL.utils.json2Sheet(data,  {skipHeader: true});
                var wb = EXCEL.utils.newWb();
                EXCEL.utils.appendSheet(wb, ws, 'Results');
                EXCEL.writeFile(wb, 'QueryResult.xlsx');
            }
        }
    }]);
});


